import pxToRem from '../utils/pxToRem'

const fonts = {
  family: {
    sans: 'Roboto, sans-serif',
    serif: 'Roboto, sans',
  },
  oldSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '4rem',
  },
  weight: {
    hairline: '100',
    thin: '200',
    light: '300',
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    extrabold: '800',
    black: '900',
  },
  sizes: {
    keys: `${pxToRem(44)}`,
    titleH1: {
      base: `${pxToRem(25)}`,
      laptop: `${pxToRem(35)}`
    },
    titleH2: {
      base: `${pxToRem(25)}`,
      laptop: `${pxToRem(25)}`
    },
    titleH3: {
      base: `${pxToRem(16)}`,
      laptop: `${pxToRem(20)}`
    },
    titleH4: {
      base: `${pxToRem(16)}`,
      laptop: `${pxToRem(18)}`
    },
    button: `${pxToRem(16)}`,
    base: `${pxToRem(16)}`,
    md: `${pxToRem(12)}`,
    sm: `${pxToRem(10)}`,
  },
  lineHeight: {
    titleH1: `${pxToRem(41.02)}`,
    titleH2: `${pxToRem(29.3)}`,
    titleH3: `${pxToRem(23.44)}`,
    titleH4: `${pxToRem(21)}`,
    button: `${pxToRem(18.75)}`,
    base: `${pxToRem(16.41)}`,
    md: `${pxToRem(14.06)}`,
    sm: `${pxToRem(11.72)}`,
  },
}

export default fonts
